import React from 'react'
import ReactProgressiveImage from 'react-progressive-image'

import { Props } from './types'

import Img from './styles'

const ProgressiveImage: React.FC<Props> = ({
  placeholder,
  src,
  src2x = undefined,
  src3x = undefined,
  ...props
}): React.ReactElement => (
  <ReactProgressiveImage
    placeholder={placeholder || ''}
    src={src}
    srcSetData={{
      sizes: '',
      srcSet: `${src} 1x${src2x ? `, ${src2x} 2x` : ''}${src3x ? `, ${src3x} 3x` : ''}`,
    }}
  >
    {(src: string, loading: boolean|undefined, srcSetData: { srcSet: string }): React.ReactElement => (
      <Img
        {...props}
        isLoading={loading}
        src={src}
        srcSet={srcSetData.srcSet}
      />
    )}
  </ReactProgressiveImage>
)

export * from './types'

export default ProgressiveImage
